import React from 'react';
import MainContainer from '../../components/main-container/main-container.component';

function Root() {
    return (
        <>
            <MainContainer />
        </>
    )
}

export default Root;
